import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";

import clsx from "clsx";

import { reducerRetailOutletsStatus } from "../../../redux/reducer/tunder/reducers/reducerRetailOutlets";
import { generateStyles } from "../../../utils/generateToastStyles";
import { AppDispatch } from "../../../redux/reducer/store";
import {
  actionUpdateRetailOutlets,
  actionGetRetailOutlets,
} from "../../../redux/action/tunder/actionRetailOutlets";

import LimitSelect from "../../custom/limitSelect/limitSelect";
import ToastPopup from "../../custom/toastPopup/toastPopup";
import Pagination from "../../pagination/pagination";
import Loader from "../../custom/loader/loader";

import "../table.scss";
import { IUserOptions } from "../../../types/interfaces";

interface IRetailOutlets {
  active: boolean;
  address: string;
  count: number;
  posId: number;
  settingId: number;
  shopCode: string;
  contract: {
    id: number;
    name: string;
  };
}

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableRetailOutlets: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { retailOutlets, retailOutletsCount, offset, status, limit } =
    useSelector((state: any) => state.tunder.retailOutlets);
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  const [activeCheckboxes, setActiveCheckboxes] = useState<boolean[]>(
    retailOutlets?.map(() => true) || []
  );

  const [isPending, setIsPending] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);

  const actualLimit =
    JSON.parse(localStorage.getItem("pageLimit") as string) || limit;

  useEffect(() => {
    dispatch(actionGetRetailOutlets(actualLimit, offset));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status === 200) {
      toast(
        (t) => (
          <ToastPopup
            title="Файл успешно загружен!"
            isSuccess={true}
            toast={toast}
            t={t}
          />
        ),
        generateStyles(true)
      );
    } else if (status === 0) {
      toast(
        (t) => (
          <ToastPopup
            title="Ошибка загрузки файлов!"
            isSuccess={false}
            toast={toast}
            t={t}
          />
        ),
        generateStyles()
      );
    }

    setTimeout(() => {
      dispatch(reducerRetailOutletsStatus(null));
    }, 5000);
  }, [dispatch, status]);

  useEffect(() => {
    if (retailOutlets && retailOutlets.length > 0) {
      setActiveCheckboxes(new Array(retailOutlets.length).fill(true));
    }
  }, [retailOutlets]);

  const handleChange = (newLimit: number, newOffset: number) => {
    setIsPending(true);
    dispatch(actionGetRetailOutlets(newLimit, newOffset)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem("pageLimit", JSON.stringify(newLimit));
  };

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 0);
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleCheckboxChange = (outlet: IRetailOutlets) => {
    const updatedCheckboxes = { ...activeCheckboxes };
    const currentActive = updatedCheckboxes[outlet.posId] ?? outlet.active;
    const newActive = !currentActive;

    updatedCheckboxes[outlet.posId] = newActive;
    setActiveCheckboxes(updatedCheckboxes);

    dispatch(
      actionUpdateRetailOutlets({
        settingId: outlet.settingId,
        posId: outlet.posId,
        shopCode: outlet.shopCode,
        active: newActive,
      })
    );
  };

  return (
    <>
      <div className="loader__wrapper">
        {(!retailOutlets || isPending) && <Loader />}
      </div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            "active__table",
          !isOpenSidebar && "closed__table",
          "table"
        )}
      >
        {(status || status !== null) && (
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 5000,
            }}
          />
        )}
        <div className="table__wrapper">
          <table>
            <thead className="tunder__thead">
              <tr className="tunder__outlets_tr">
                <th>
                  <span className="filter__title">Активна</span>
                </th>
                <th>
                  <span className="filter__title">Код Тандер</span>
                </th>
                <th>
                  <span className="filter__title">ID TT</span>
                </th>
                <th>
                  <span className="filter__title">Адрес</span>
                </th>
                <th>
                  <span className="filter__title">Контракт</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {retailOutlets &&
                retailOutlets.map((outlet: IRetailOutlets) => (
                  <tr key={outlet.posId}>
                    <td>
                      <input
                        disabled={
                          !(
                            claims.includes("admin") ||
                            claims.includes("tander:view")
                          )
                        }
                        onChange={() => handleCheckboxChange(outlet)}
                        defaultChecked={outlet.active}
                        type="checkbox"
                      />
                    </td>
                    <td>{outlet.shopCode}</td>
                    <td>{outlet.posId}</td>
                    <td>{outlet.address}</td>
                    <td>{outlet.contract.name}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <div className="pagination__count">Всего: {retailOutletsCount}</div>
          <div className="pagination__str">
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            count={retailOutletsCount}
            currentPage={currentPage}
            startPage={startPage}
            limit={actualLimit}
          />
        </div>
      </div>
    </>
  );
};

export default TableRetailOutlets;
